import { render, staticRenderFns } from "./PilotListItem.vue?vue&type=template&id=36888c10&scoped=true&"
import script from "./PilotListItem.vue?vue&type=script&lang=ts&"
export * from "./PilotListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PilotListItem.vue?vue&type=style&index=0&id=36888c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36888c10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VIcon,VImg})
